import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'
// 验券接口
export function verifyForH5(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/verifyForH5`,
    method: 'post',
    data
  })
}
// 发送验证码
export function sendVerifyCodeForH5(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/sendVerifyCodeForH5`,
    method: 'post',
    data
  })
}
// 登录
export function loginForH5(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/loginForH5`,
    method: 'post',
    data
  })
}
// 列表
export function listCodeForH5(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/listCodeForH5`,
    method: 'post',
    token: sessionStorage.getItem('mtH5Token'),
    data
  })
}
// 详情
export function queryVerifyResForH5(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/queryVerifyResForH5`,
    method: 'post',
    token: sessionStorage.getItem('mtH5Token'),
    data
  })
}
